module.exports = __webpack_public_path__ + "static/media/cedula2.f1308dd8.png";